import { DecodedToken } from "@/modules/common/context/auth/auth.context";

export interface IBaseAnalyticsService {
  init(): Promise<void>;
  identify(user: DecodedToken): void;
  setUserAttributes(attributes: Record<string, unknown>): void;
  pageView(event: string, payload?: Record<string, unknown>): void;
  track(event: string, payload?: Record<string, unknown>): void;
  unidentify(): void;
}

export abstract class BaseAnalyticsService implements IBaseAnalyticsService {
  public abstract init(): Promise<void>;
  public abstract identify(user: DecodedToken): void;
  public abstract setUserAttributes(attributes: Record<string, unknown>): void;
  public abstract pageView(
    event: string,
    payload?: Record<string, unknown>
  ): void;
  public abstract track(event: string, payload?: Record<string, unknown>): void;
  public abstract unidentify(): void;
}
